import { Component } from '@angular/core';
import { Feature } from '@freelancer/feature-flags';
import { ButtonColor } from '@freelancer/ui/button';

@Component({
  selector: 'app-navigation-secondary-projects',
  template: `
    <app-bar flTrackingSection="SubnavProjects">
      <app-bar-item
        link="/dashboard/projects.php"
        [exactLink]="true"
        i18n="Secondary navigation projects bar item"
        flTrackingLabel="MyProjects"
      >
        My Projects
      </app-bar-item>
      <app-bar-item
        link="/dashboard"
        [exactLink]="true"
        i18n="Secondary navigation projects bar item"
        flTrackingLabel="Dashboard"
      >
        Dashboard
      </app-bar-item>
      <app-bar-item
        link="/messages"
        i18n="Secondary navigation projects bar item"
        flTrackingLabel="Inbox"
      >
        Inbox
      </app-bar-item>
      <app-bar-item
        link="/dashboard/feedback.php"
        [exactLink]="true"
        i18n="Secondary navigation projects bar item"
        flTrackingLabel="Feedback"
      >
        Feedback
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.GIVE_GET"
        link="/give"
        [exactLink]="true"
        i18n="Secondary navigation projects bar item"
        flTrackingLabel="FreeCredit"
      >
        Free Credit
      </app-bar-item>
      <fl-button
        [color]="ButtonColor.PRIMARY"
        link="/post-project"
        i18n="Secondary navigation projects bar post project button"
        flTrackingLabel="PostProjectButton"
      >
        Post a Project
      </fl-button>
    </app-bar>
  `,
})
export class NavigationSecondaryProjectsComponent {
  Feature = Feature;
  ButtonColor = ButtonColor;
}
